const formats = [
  { icon: 'ri-calendar-check-line', title: 'Корпоративный тренинг', desc: 'Практическая программа для управленческой команды на 1–2 дня: диагностика, инструменты, разбор реальных ситуаций и отработка разговоров.' },
  { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Несколько модулей с практикой между встречами. Руководители применяют инструменты в работе и возвращаются для разбора сложных случаев.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Моделирование конфликтных и переговорных ситуаций в игровой форме с высокой вовлечённостью и безопасной средой для ошибок.' },
  { icon: 'ri-vip-crown-line', title: 'Управленческая программа', desc: 'Развитие конфликтологической компетентности в составе комплексного обучения руководителей наряду с другими управленческими навыками.' },
  { icon: 'ri-user-voice-line', title: 'Индивидуальный коучинг', desc: 'Разбор конкретных конфликтных ситуаций руководителя: подготовка к разговору, анализ результатов, выработка стратегии поведения.' },
  { icon: 'ri-phone-line', title: 'Сопровождение', desc: 'Разбор реальных конфликтов после обучения и поддержка внедрения инструментов в ежедневную управленческую практику.' },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Как можно обучать управлению конфликтами
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Формат подбирается под задачу компании, количество участников и глубину проработки
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}